/* @generated */

// ../src/menu/menu.ts
import "focus-visible";

// ../src/menu/action_item.tsx
import * as React7 from "react";

// ../src/menu/row.tsx
import classNames5 from "classnames";
import * as React6 from "react";

// ../src/menu/context.tsx
import * as React from "react";
import { createMenuRows } from "@dropbox/dig-components/hooks";
var defaultValue = {
  value: void 0,
  setSelected: () => false,
  setFocused: () => false,
  isPortaled: true,
  parentMenuContext: void 0,
  menuRows: createMenuRows(),
  registerActiveSubmenu: () => false,
  closeActiveSubmenu: () => false,
  shouldMatchContainerWidth: false,
  isSubmenu: false,
  hasActiveSubmenu: false,
  slideSubmenu: false,
  topLevelTriggerRef: void 0,
  closeMenu: () => false,
  closeOnSelection: true
};
var MenuContext = React.createContext(defaultValue);
MenuContext.displayName = "MenuContext";
var defaultContentValue = {
  placement: "bottom-start",
  offset: 4,
  isRootMenuOpen: false
};
var MenuContentContext = React.createContext(defaultContentValue);
MenuContentContext.displayName = "MenuContentContext";

// ../src/menu/row_accessory.tsx
import classNames from "classnames";
import * as React2 from "react";

// ../src/menu/menu.css.ts
import { createRuntimeFn as _7a468 } from "@vanilla-extract/recipes/createRuntimeFn";
var cookMenuRowClassName = _7a468({ defaultClassName: "dig-1azk22qh_21-1-1", variantClassNames: { hasReducedMotion: { true: "dig-1azk22qi_21-1-1", false: "dig-1azk22qj_21-1-1" }, isInteractive: { true: "dig-1azk22qk_21-1-1", false: "dig-1azk22ql_21-1-1" }, focus: { true: "dig-1azk22qm_21-1-1", false: "dig-1azk22qn_21-1-1" }, active: { true: "dig-1azk22qo_21-1-1", false: "dig-1azk22qp_21-1-1" }, hover: { true: "dig-1azk22qq_21-1-1", false: "dig-1azk22qr_21-1-1" }, disabled: { true: "dig-1azk22qs_21-1-1", false: "dig-1azk22qt_21-1-1" } }, defaultVariants: { hasReducedMotion: false, isInteractive: false, focus: false, active: false, hover: false, disabled: false }, compoundVariants: [[{ isInteractive: true, focus: true }, "dig-1azk22qe_21-1-1"], [{ isInteractive: true, hover: true }, "dig-1azk22qg_21-1-1"], [{ isInteractive: true, active: true }, "dig-1azk22qf_21-1-1"]] });
var cookMenuSegmentClassName = _7a468({ defaultClassName: "dig-1azk22q5_21-1-1", variantClassNames: { withoutPadding: { true: "dig-1azk22q6_21-1-1", false: "dig-1azk22q7_21-1-1" } }, defaultVariants: { withoutPadding: false }, compoundVariants: [] });
var menuBackdropClassName = "dig-1azk22q1_21-1-1";
var menuCanvasClassName = "dig-1azk22q4_21-1-1";
var menuClassName = "dig-1azk22q0_21-1-1";
var menuContentClassName = "dig-1azk22q3_21-1-1";
var menuRowAccessoryClassName = "dig-1azk22qx_21-1-1";
var menuRowContentClassName = "dig-1azk22qu_21-1-1";
var menuRowDestructiveToneClassName = "dig-1azk22qd_21-1-1";
var menuRowNeutralToneClassName = "dig-1azk22qc_21-1-1";
var menuRowSubtitleClassName = "dig-1azk22qw_21-1-1";
var menuRowTitleClassName = "dig-1azk22qv_21-1-1";
var menuSegmentLabelClassName = "dig-1azk22q8_21-1-1";
var submenuClassName = "dig-1azk22q2_21-1-1";

// ../src/menu/row_accessory.tsx
var RowAccessory = ({ className, children, ...rest }) => {
  const cls = classNames("dig-Menu-row-accessory", menuRowAccessoryClassName, className);
  return /* @__PURE__ */ React2.createElement("div", { className: cls, ...rest }, children);
};
RowAccessory.displayName = "RowAccessory";

// ../src/menu/row_content.tsx
import classNames2 from "classnames";
import * as React3 from "react";
var RowContent = ({ className, children, ...rest }) => {
  const cls = classNames2("dig-Menu-row-content", menuRowContentClassName, className);
  return /* @__PURE__ */ React3.createElement("div", { className: cls, ...rest }, children);
};
RowContent.displayName = "RowContent";

// ../src/menu/row_title.tsx
import classNames3 from "classnames";
import * as React4 from "react";
var RowTitle = ({ className, children, ...rest }) => {
  const cls = classNames3("dig-Menu-row-title", menuRowTitleClassName, className);
  return /* @__PURE__ */ React4.createElement("div", { className: cls, ...rest }, children);
};
RowTitle.displayName = "RowTitle";

// ../src/menu/row_subtitle.tsx
import classNames4 from "classnames";
import * as React5 from "react";
var RowSubtitle = ({ className, children, ...rest }) => {
  const cls = classNames4("dig-Menu-row-subtitle", menuRowSubtitleClassName, className);
  return /* @__PURE__ */ React5.createElement("div", { className: cls, ...rest }, children);
};
RowSubtitle.displayName = "RowSubtitle";

// ../src/menu/row.tsx
import { useMenuItem, createMenuRows as createMenuRows2 } from "@dropbox/dig-components/hooks";
import "focus-visible";
import { usePrefersReducedMotion } from "@dropbox/dig-foundations";
var Row = React6.forwardRef(
  ({
    tagName: TagName = "div",
    role = "menuitem",
    className,
    children,
    onMouseEnter,
    withTitle,
    withSubtitle,
    withLeftAccessory,
    withRightAccessory,
    disabled = false,
    interactive = false,
    // Removes it from the tab sequence since we're managing it via JS.
    // Users should only be able to navigate via arrow keys. Tabbing would
    // shift the focus out of the parent menu container.
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    tabIndex = -1,
    tone = "neutral",
    preferComposition = false,
    _isSubmenuTrigger = false,
    onClick,
    _pseudoClass,
    ...rest
  }, ref) => {
    const localRef = React6.useRef(null);
    const { menuRows, parentMenuContext, closeActiveSubmenu } = React6.useContext(MenuContext);
    const rows = _isSubmenuTrigger ? parentMenuContext && parentMenuContext.menuRows || createMenuRows2() : menuRows;
    const { getItemProps } = useMenuItem({ interactive, disabled, ref: localRef, role }, rows);
    const { hasReducedMotion } = usePrefersReducedMotion();
    const cls = classNames5(
      "dig-Menu-row",
      `dig-Menu-row--${tone}`,
      cookMenuRowClassName({
        hasReducedMotion,
        isInteractive: interactive,
        focus: _pseudoClass === "focus",
        active: _pseudoClass === "active",
        hover: _pseudoClass === "hover"
      }),
      {
        [menuRowNeutralToneClassName]: tone === "neutral",
        [menuRowDestructiveToneClassName]: tone === "destructive",
        "dig-Menu-row--disabled": disabled,
        "dig-Menu-row--interactive": interactive,
        "dig-Menu-row--active": _pseudoClass === "active",
        "dig-Menu-row--focused": _pseudoClass === "focus",
        "dig-Menu-row--hover": _pseudoClass === "hover",
        "dig-Menu-row--reducedMotion": hasReducedMotion
      },
      className
    );
    const handleMouseEnter = (evt) => {
      closeActiveSubmenu();
      if (onMouseEnter) {
        onMouseEnter(evt);
      }
    };
    React6.useImperativeHandle(ref, () => ({
      // `focus()` is required for submenu keyboard navigation
      focus: (options) => {
        if (!localRef.current)
          return;
        return localRef.current.focus(options);
      },
      // The set of properties below are used by `floating-ui`
      getBoundingClientRect: () => {
        if (!localRef.current)
          return;
        return localRef.current.getBoundingClientRect();
      }
    }));
    return /* @__PURE__ */ React6.createElement(
      TagName,
      {
        className: cls,
        ref: localRef,
        ...getItemProps({
          onMouseEnter: handleMouseEnter,
          // If this has been disabled we need to prevent click events from being called
          // since we do not use a `disabled` attribute or a native `button` element.
          onClick: (evt) => {
            if (disabled) {
              evt.preventDefault();
              return;
            }
            if (onClick) {
              onClick(evt);
            }
          },
          ...rest
        })
      },
      preferComposition && children,
      !preferComposition && /* @__PURE__ */ React6.createElement(React6.Fragment, null, withLeftAccessory && /* @__PURE__ */ React6.createElement(RowAccessory, null, withLeftAccessory), /* @__PURE__ */ React6.createElement(RowContent, null, /* @__PURE__ */ React6.createElement(RowTitle, null, withTitle || children), withSubtitle && /* @__PURE__ */ React6.createElement(RowSubtitle, null, withSubtitle)), withRightAccessory && /* @__PURE__ */ React6.createElement(RowAccessory, null, withRightAccessory))
    );
  }
);
Row.displayName = "Row";

// ../src/menu/action_item.tsx
var ActionItem = React7.forwardRef(
  ({ children, disabled, value, onClick, onFocus, ...rest }, ref) => {
    const { setFocused, setSelected } = React7.useContext(MenuContext);
    const handleClick = (evt) => {
      setSelected(value, evt);
      if (onClick) {
        onClick(evt);
      }
    };
    const handleFocus = (evt) => {
      setFocused(value);
      if (onFocus) {
        onFocus(evt);
      }
    };
    return /* @__PURE__ */ React7.createElement(
      Row,
      {
        interactive: true,
        disabled,
        onClick: handleClick,
        onFocus: handleFocus,
        ...rest,
        ref
      },
      children
    );
  }
);
ActionItem.displayName = "ActionItem";

// ../src/menu/canvas.tsx
import classnames from "classnames";
import * as React8 from "react";
import { useTheme } from "@dropbox/dig-foundations";
var Canvas = ({ className, style, children, ...rest }) => {
  const { inverse, maxHeight } = React8.useContext(MenuContext);
  const inverseClassName = useTheme().getInverseProps().className;
  const cls = classnames(className, "dig-Menu-canvas", menuCanvasClassName, {
    [inverseClassName]: inverse
  });
  return /* @__PURE__ */ React8.createElement("div", { className: cls, role: "presentation", ...rest, style: { ...style, maxHeight } }, children);
};
Canvas.displayName = "Canvas";

// ../src/menu/content.tsx
import classNames6 from "classnames";
import * as React11 from "react";

// ../src/menu/menu_motion.tsx
import * as React9 from "react";
import { Motion } from "@dropbox/dig-components/motion";
import { usePrefersReducedMotion as usePrefersReducedMotion2 } from "@dropbox/dig-foundations";
var SUBMENU_OFFSET = 48;
var PARENT_OFFSET = 24;
var MENU_MOTION_DURATION = 125;
var MENU_SLIDE_DURATION_MS = MENU_MOTION_DURATION;
var AppearMenuMotion = ({
  animationDirection,
  offset: offset2,
  isOpen,
  isRootMenuOpen,
  onTransitionComplete,
  children
}) => {
  const { hasReducedMotion } = usePrefersReducedMotion2();
  const verticalOffset = animationDirection === "up" ? offset2 : -1 * offset2;
  const onEntered = React9.useCallback(() => {
    if (typeof onTransitionComplete === "function") {
      onTransitionComplete({ isOpen: true });
    }
  }, [onTransitionComplete]);
  const onExited = React9.useCallback(() => {
    if (typeof onTransitionComplete === "function") {
      onTransitionComplete({ isOpen: false });
    }
  }, [onTransitionComplete]);
  return (
    // Note that menu must be mounted for animation to work when isOpen is
    // triggered, which is why only pass it through to the in prop and
    // children instead.
    /* @__PURE__ */ React9.createElement(
      Motion,
      {
        _disableMotionDuration: hasReducedMotion,
        onEntered,
        onExited,
        transitionIn: {
          transitions: [
            { property: animationDirection, value: 0 },
            { property: "opacity", value: 1 }
          ],
          easing: "enter",
          duration: MENU_MOTION_DURATION
        },
        transitionOut: {
          transitions: [
            { property: "opacity", value: 0 },
            { property: animationDirection, value: verticalOffset }
          ],
          easing: "leave",
          duration: MENU_MOTION_DURATION
        },
        style: { opacity: 0 },
        in: isOpen && isRootMenuOpen,
        mountOnEnter: true,
        unmountOnExit: true
      },
      ({ state: motionState, style }) => {
        const isVisible = isOpen || motionState !== "exited";
        return isVisible && children({ canvasStyle: style, overlayStyle: {} });
      }
    )
  );
};
AppearMenuMotion.displayName = "AppearMenuMotion";
var getDefaultSlideStyle = (motion, isSubmenu) => {
  if (motion === 2 /* CloseLeft */) {
    return { transform: `translate(-${PARENT_OFFSET}px, ${0}px)`, opacity: 0 };
  }
  if (isSubmenu) {
    return { transform: `translate(${SUBMENU_OFFSET}px, ${0}px)`, opacity: 0 };
  }
  return {};
};
var SlideMenuMotion = ({
  submenuMotion,
  isSubmenu,
  animationDirection,
  offset: offset2,
  isRootMenuOpen,
  style: propsStyle,
  children
}) => {
  const defaultStyle = getDefaultSlideStyle(submenuMotion, isSubmenu);
  const { hasReducedMotion } = usePrefersReducedMotion2();
  const isSubmenuOpen = submenuMotion === 0 /* OpenLeft */ || submenuMotion === 1 /* OpenRight */;
  const verticalOffset = animationDirection === "up" ? offset2 : -1 * offset2;
  return /* @__PURE__ */ React9.createElement(
    Motion,
    {
      _disableMotionDuration: hasReducedMotion,
      transitionIn: {
        transitions: [
          { property: "left", value: 0 },
          { property: animationDirection, value: 0 },
          { property: "opacity", value: 1 }
        ],
        easing: "transition",
        duration: MENU_MOTION_DURATION
      },
      transitionOut: {
        transitions: [
          // Check if this is a submenu first so we can do the correct transition.
          // Submenus need to slide left/right
          // the root menu needs to slide up/down
          { property: "left", value: isSubmenu ? PARENT_OFFSET : 0 },
          { property: animationDirection, value: isSubmenu ? 0 : verticalOffset },
          { property: "opacity", value: 0 }
        ],
        easing: "transition",
        duration: MENU_MOTION_DURATION
      },
      style: { opacity: 0 },
      in: isSubmenuOpen
    },
    ({ state: slideLeftState, style: slideLeftStyle }) => {
      return /* @__PURE__ */ React9.createElement(
        Motion,
        {
          _disableMotionDuration: hasReducedMotion,
          transitionIn: {
            transitions: [
              { property: "left", value: 0 },
              { property: animationDirection, value: 0 },
              { property: "opacity", value: 1 }
            ],
            easing: "transition",
            duration: MENU_MOTION_DURATION
          },
          transitionOut: {
            transitions: [
              { property: "left", value: isSubmenu ? -1 * SUBMENU_OFFSET : 0 },
              { property: animationDirection, value: isSubmenu ? 0 : verticalOffset },
              { property: "opacity", value: 0 }
            ],
            easing: "transition",
            duration: MENU_MOTION_DURATION
          },
          style: { opacity: 0 },
          in: isSubmenuOpen
        },
        ({ state: slideRightState, style: slideRightStyle }) => {
          if (!isRootMenuOpen) {
            return children({
              canvasStyle: { ...propsStyle },
              overlayStyle: {}
            });
          }
          if (submenuMotion === 4 /* None */) {
            return children({
              canvasStyle: {},
              overlayStyle: { visibility: "hidden", pointerEvents: "none" }
            });
          }
          const isLeftDirection = submenuMotion === 2 /* CloseLeft */ || submenuMotion === 0 /* OpenLeft */;
          const isVisible = isSubmenuOpen || slideLeftState !== "exited" || slideRightState !== "exited";
          const overlayStyle = isVisible ? {} : { visibility: "hidden", pointerEvents: "none" };
          const canvasStyle = isVisible ? {
            ...propsStyle,
            ...isLeftDirection ? { ...slideLeftStyle } : { ...slideRightStyle }
          } : {
            ...propsStyle,
            ...defaultStyle
          };
          return children({
            canvasStyle,
            overlayStyle
          });
        }
      );
    }
  );
};
SlideMenuMotion.displayName = "SlideMenuMotion";
var MenuMotion = ({
  children,
  submenuMotion,
  isSubmenu,
  slideSubmenu,
  ...rest
}) => {
  if (!slideSubmenu) {
    return /* @__PURE__ */ React9.createElement(AppearMenuMotion, { ...rest }, children);
  }
  return /* @__PURE__ */ React9.createElement(AppearMenuMotion, { ...rest }, ({ canvasStyle: style }) => {
    return /* @__PURE__ */ React9.createElement(
      SlideMenuMotion,
      {
        isSubmenu,
        submenuMotion,
        slideSubmenu,
        style,
        ...rest
      },
      children
    );
  });
};
MenuMotion.displayName = "MenuMotion";

// ../src/menu/menu_overlay.tsx
import cx from "classnames";
import * as React10 from "react";
import { useIsomorphicLayoutEffect } from "@react-hookz/web";
import {
  useFloating,
  autoUpdate,
  flip,
  shift,
  limitShift,
  size,
  offset
} from "@floating-ui/react";
import { ELEVATED_BASE_INDEX, Layer } from "@dropbox/dig-components/layer";
var MenuOverlay = React10.forwardRef(
  ({
    className,
    children,
    placement,
    anchorRef,
    offsetDistance = 0,
    auto = false,
    isPortaled = true,
    positioningStrategy = "absolute",
    style,
    ...rest
  }, ref) => {
    const { setMaxMenuHeight } = React10.useContext(MenuContext);
    const [shouldReAttachAnchorRef, setShouldReAttachAnchorRef] = React10.useState(false);
    const applyFn = React10.useCallback(
      ({ availableHeight }) => {
        setMaxMenuHeight && setMaxMenuHeight(availableHeight);
      },
      [setMaxMenuHeight]
    );
    const {
      x,
      y,
      refs,
      strategy,
      update,
      placement: floatingPlacement
    } = useFloating({
      placement,
      strategy: positioningStrategy,
      // We assume RO is pollyfilled.
      whileElementsMounted: (reference, floating, update2) => autoUpdate(reference, floating, update2, {
        elementResize: true
      }),
      middleware: [
        offset(offsetDistance),
        // 'bestFit' is the only option here that will work nicely with the `size` middleware
        // adjusting the height of the menu canvas.
        // `initialPlacement` causes a lot of jerkiness on scroll.
        // @see https://floating-ui.com/docs/size#using-with-flip
        ...auto ? [flip({ fallbackStrategy: "bestFit" })] : [],
        size({
          apply: applyFn
        }),
        ...auto ? [
          shift({
            limiter: limitShift()
          })
        ] : []
      ]
    });
    useIsomorphicLayoutEffect(() => {
      refs.setReference(anchorRef.current);
    }, [refs, anchorRef]);
    useIsomorphicLayoutEffect(() => {
      if (shouldReAttachAnchorRef) {
        refs.setReference(anchorRef.current);
        setShouldReAttachAnchorRef(false);
      }
    }, [refs, anchorRef, shouldReAttachAnchorRef]);
    React10.useImperativeHandle(
      ref,
      () => ({
        update: () => {
          update();
          setShouldReAttachAnchorRef(true);
        }
      }),
      [update]
    );
    const floatingX = x ? Math.round(x) : 0;
    const floatingY = y ? Math.round(y) : 0;
    const cls = cx("dig-Menu-Overlay", `dig-Menu-Overlay--${floatingPlacement}`, className);
    return /* @__PURE__ */ React10.createElement(Layer, { _elevateByZ: ELEVATED_BASE_INDEX, isPortaled }, /* @__PURE__ */ React10.createElement(
      "div",
      {
        className: cls,
        ref: refs.setFloating,
        style: {
          ...style,
          position: strategy,
          top: "0",
          left: "0",
          transform: `translate3d(${floatingX}px,${floatingY}px,0)`
        },
        ...rest
      },
      children
    ));
  }
);
MenuOverlay.displayName = "MenuOverlay";

// ../src/menu/content.tsx
var getAnimationDirection = (placement) => {
  switch (placement) {
    case "top":
    case "top-start":
    case "top-end":
    default:
      return "up";
    case "bottom":
    case "bottom-start":
    case "bottom-end":
      return "down";
  }
};
var Content = React11.forwardRef(
  ({
    children,
    className,
    auto = true,
    placement = "bottom-start",
    open = false,
    triggerRef,
    // By default, the Menu content will render with a 4px space between the trigger
    triggerOffset = 4,
    positioningStrategy = "absolute",
    onContentOpened,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    tabIndex = -1,
    motionProvider: MotionProvider = MenuMotion,
    onTransitionComplete,
    minWidth = 90,
    ...rest
  }, ref) => {
    const overlayRef = React11.useRef(null);
    const animationDirection = getAnimationDirection(placement);
    const [containerStyles, setContainerStyles] = React11.useState({});
    const [menuMotion, setMenuMotion] = React11.useState(4 /* None */);
    const {
      contentRef,
      shouldMatchContainerWidth,
      isPortaled,
      isSubmenu,
      hasActiveSubmenu,
      slideSubmenu
    } = React11.useContext(MenuContext);
    const cls = classNames6(
      "dig-Menu-content",
      `dig-Menu-content--${placement}`,
      menuContentClassName,
      className
    );
    const { isRootMenuOpen: parentIsRootMenuOpen } = React11.useContext(MenuContentContext);
    const isRootMenuOpen = isSubmenu ? parentIsRootMenuOpen : open;
    const contentDefaultValue = { placement, offset: triggerOffset, isRootMenuOpen };
    React11.useEffect(() => {
      if (slideSubmenu) {
        if (hasActiveSubmenu) {
          setMenuMotion(2 /* CloseLeft */);
        } else {
          setMenuMotion(0 /* OpenLeft */);
        }
      }
    }, [hasActiveSubmenu, slideSubmenu]);
    React11.useEffect(() => {
      if (slideSubmenu) {
        if (!isRootMenuOpen) {
          setMenuMotion(4 /* None */);
        } else if (open) {
          setMenuMotion(1 /* OpenRight */);
        } else {
          setMenuMotion(3 /* CloseRight */);
        }
      }
    }, [open, slideSubmenu, isRootMenuOpen]);
    React11.useEffect(
      () => {
        if (open && triggerRef.current) {
          setContainerStyles({
            minWidth: shouldMatchContainerWidth || minWidth === "matchContainingWidth" ? triggerRef.current.getBoundingClientRect().width : minWidth
          });
        }
      },
      // eslint-disable-next-line react-compiler/react-compiler
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [open]
    );
    React11.useImperativeHandle(ref, () => ({
      update: () => {
        if (overlayRef.current) {
          overlayRef.current.update();
        }
      }
    }));
    React11.useEffect(() => {
      if (open && onContentOpened) {
        onContentOpened();
      }
    }, [open]);
    const normalizedMotionOffset = React11.useMemo(() => {
      let offset2 = 0;
      if (typeof triggerOffset === "number") {
        offset2 = triggerOffset;
      } else if (typeof triggerOffset === "object") {
        offset2 = triggerOffset.mainAxis || triggerOffset.crossAxis;
      }
      return offset2 ? offset2 : 0;
    }, [triggerOffset]);
    return /* @__PURE__ */ React11.createElement(MenuContentContext.Provider, { value: contentDefaultValue }, /* @__PURE__ */ React11.createElement(
      MotionProvider,
      {
        animationDirection,
        offset: normalizedMotionOffset,
        isOpen: open,
        isSubmenu,
        submenuMotion: menuMotion,
        slideSubmenu,
        isRootMenuOpen,
        onTransitionComplete
      },
      ({ canvasStyle, overlayStyle }) => {
        return /* @__PURE__ */ React11.createElement(
          MenuOverlay,
          {
            anchorRef: triggerRef,
            auto,
            placement,
            offsetDistance: triggerOffset,
            positioningStrategy,
            isPortaled,
            style: { ...overlayStyle, ...containerStyles },
            ref: overlayRef
          },
          /* @__PURE__ */ React11.createElement("nav", { className: cls, ref: contentRef, tabIndex: -1, ...rest }, /* @__PURE__ */ React11.createElement(Canvas, { style: canvasStyle }, children))
        );
      }
    ));
  }
);
Content.displayName = "Content";

// ../src/menu/link_item.tsx
import * as React12 from "react";
var LinkItem = React12.forwardRef(
  ({ children, disabled, href, onClick, ...rest }, ref) => {
    const { closeMenu, closeOnSelection } = React12.useContext(MenuContext);
    const handleClick = (evt) => {
      if (closeOnSelection) {
        closeMenu({ autoFocus: false });
      }
      if (onClick) {
        onClick(evt);
      }
    };
    return /* @__PURE__ */ React12.createElement(
      Row,
      {
        tagName: "a",
        href,
        onClick: handleClick,
        interactive: true,
        disabled,
        ...rest,
        ref
      },
      children
    );
  }
);
LinkItem.displayName = "LinkItem";

// ../src/menu/segment.tsx
import classNames7 from "classnames";
import { Text } from "@dropbox/dig-components/typography";
import * as React13 from "react";
var Segment = ({
  className,
  children,
  withLabel,
  _withoutPadding,
  ...rest
}) => {
  const cls = classNames7(
    "dig-Menu-segment",
    { "dig-Menu-segment--withoutPadding": _withoutPadding },
    cookMenuSegmentClassName({
      withoutPadding: _withoutPadding
    }),
    className
  );
  return /* @__PURE__ */ React13.createElement("div", { className: cls, ...rest }, withLabel && /* @__PURE__ */ React13.createElement("div", { className: classNames7("dig-Menu-segment-label", menuSegmentLabelClassName) }, /* @__PURE__ */ React13.createElement(Text, { size: "small", color: "subtle", isBold: true }, withLabel)), children);
};
Segment.displayName = "Segment";

// ../src/menu/select_item.tsx
import * as React14 from "react";
import { UIIcon } from "@dropbox/dig-icons";
import { CheckmarkLine } from "@dropbox/dig-icons/assets";
var SelectItem = ({
  children,
  selected = false,
  role = "menuitemradio",
  ...rest
}) => {
  const withLeftAccessory = selected ? (
    // UIIcon here has no aria-label which is fine because this is just an additional visual
    // indicator and is not a standalone button on it's own (ie: the icon is not focusable
    // by itself).
    /* @__PURE__ */ React14.createElement(UIIcon, { src: CheckmarkLine })
  ) : (
    // Setting prop to true will make sure the accessory is always rendered even
    // if empty, so items are always aligned regardless of check icon or not
    true
  );
  return /* @__PURE__ */ React14.createElement(ActionItem, { role, "aria-checked": selected, withLeftAccessory, ...rest }, children);
};
SelectItem.displayName = "SelectItem";

// ../src/menu/submenu.tsx
import * as React17 from "react";
import classNames9 from "classnames";

// ../src/_global/constants.ts
var ensureFocusable = (selector) => {
  return `${selector}:not([tabindex="-1"])`;
};
var TAB_KEY = "Tab";
var ENTER_KEY = "Enter";
var ESC_KEY = "Escape";
var SPACEBAR_KEY = " ";
var UP_ARROW_KEY = "ArrowUp";
var DOWN_ARROW_KEY = "ArrowDown";
var LEFT_ARROW_KEY = "ArrowLeft";
var RIGHT_ARROW_KEY = "ArrowRight";
var DELETE_KEY = "Delete";
var BACKSPACE_KEY = "Backspace";
var NONE_SELECTED_INDEX = -2;
var LAST_SELECTED_INDEX = -1;
var FOCUSABLE_SELECTOR = (additionalSelectors) => Array.prototype.concat.apply(
  [],
  [
    // buttons and links
    [`button`, `[role="button"]`, `[role="link"]`, `[href]`].map(ensureFocusable),
    // controls
    [`select`, `textarea`, `[role="textbox"]`].map(ensureFocusable),
    additionalSelectors,
    // other
    [`[tabindex]:not([tabindex="-1"])`]
  ]
).join(",");
var VISUALLY_HIDDEN_CSS = {
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: "1px",
  margin: "0 -1px -1px 0",
  overflow: "hidden",
  padding: "0",
  position: "absolute",
  width: "1px",
  whiteSpace: "nowrap"
};
var buttonDataAttributeName = "data-dig-button";
var buttonDataSelector = `[${buttonDataAttributeName}]`;
var buttonContentDataAttributeName = "data-dig-button-content";
var buttonContentDataSelector = `[${buttonContentDataAttributeName}]`;
var splitButtonDataAttributeName = "data-dig-split-button";
var splitButtonDataSelector = `[${splitButtonDataAttributeName}]`;
var iconButtonDataAttributeName = "data-dig-icon-button";
var iconButtonDataSelector = `[${iconButtonDataAttributeName}]`;

// ../src/menu/submenu.tsx
import {
  focusItem,
  isFocusingMenuRow,
  moveFocusBackward,
  moveFocusForward
} from "@dropbox/dig-components/hooks";
import { UIIcon as UIIcon2 } from "@dropbox/dig-icons";
import { ChevronLeftLine, ChevronRightLine } from "@dropbox/dig-icons/assets";

// ../src/menu/wrapper.tsx
import classNames8 from "classnames";
import * as React16 from "react";
import { ClickOutside } from "@dropbox/dig-components/click_outside";
import { useMenu, useSubmenu } from "@dropbox/dig-components/hooks";

// ../src/menu/constants.ts
var INTERACTIVE_MENU_ROW_CLASSNAME = "dig-Menu-row--interactive";
var INTERACTIVE_MENU_ROW_SELECTORS = (
  // interactive Menu.Rows
  [
    `.${INTERACTIVE_MENU_ROW_CLASSNAME}[role="menuitem"]`,
    `.${INTERACTIVE_MENU_ROW_CLASSNAME}[role="menuitemcheckbox"]`,
    `.${INTERACTIVE_MENU_ROW_CLASSNAME}[role="menuitemradio"]`
  ]
);

// ../src/menu/useMaxMenuHeight.ts
import * as React15 from "react";
var SCREEN_EDGE_OFFSET = 8;
var DEFAULT_MAX_HEIGHT = 200;
var useMaxMenuHeight = (hasMaxHeight) => {
  const [maxHeight, _setMaxHeight] = React15.useState(void 0);
  const setMaxHeight = React15.useCallback(
    (availableHeight) => {
      let calculatedMaxHeight = availableHeight;
      switch (typeof hasMaxHeight) {
        case "number":
          calculatedMaxHeight = Math.min(hasMaxHeight, availableHeight);
          break;
        case "boolean":
          calculatedMaxHeight = hasMaxHeight ? Math.min(DEFAULT_MAX_HEIGHT, availableHeight) : (
            // This is the default case for this hook where it could cause the canvas
            // to expand to the screen edge, in which case lets take a little height off of it
            // so it doesn't but up directly against the screen edge.
            calculatedMaxHeight - SCREEN_EDGE_OFFSET
          );
      }
      const adjustedMaxHeight = Math.max(DEFAULT_MAX_HEIGHT, calculatedMaxHeight);
      _setMaxHeight(adjustedMaxHeight);
    },
    [hasMaxHeight, _setMaxHeight]
  );
  return [maxHeight, setMaxHeight];
};

// ../src/menu/wrapper.tsx
import { useTheme as useTheme2 } from "@dropbox/dig-foundations";
var Wrapper = React16.forwardRef(
  ({
    className,
    children,
    onSelection,
    onToggle,
    closeOnSelection = true,
    closeOnBlur = true,
    isPortaled = true,
    matchContainingWidth = false,
    hasMaxHeight = false,
    shouldPropagateClickOutsideMouseEvents = false,
    shouldFocusDisabledRows = true,
    isBlock = false,
    slideSubmenu = false,
    _isSubmenu = false,
    closeOnBlurWhenDefaultPrevented = true,
    inverse = false,
    isContentLabelledByTrigger = false,
    ...rest
  }, ref) => {
    const inverseClassName = useTheme2().getInverseProps().className;
    const cls = classNames8("dig-Menu", menuClassName, { [inverseClassName]: inverse }, className);
    const [maxHeight, setMaxMenuHeight] = useMaxMenuHeight(hasMaxHeight);
    const triggerRef = React16.useRef(null);
    const contentRef = React16.useRef(null);
    const contentOverlayRef = React16.useRef(null);
    const {
      close: closeActiveSubmenu,
      register: registerActiveSubmenu,
      hasActiveSubmenu
    } = useSubmenu();
    const {
      isOpen,
      openMenu,
      closeMenu,
      toggleMenu,
      value,
      setSelected,
      setFocused,
      getRootProps,
      getTriggerProps,
      getContentProps,
      menuRows,
      focusTrigger
    } = useMenu({
      triggerRef,
      contentRef,
      onSelection,
      onToggle,
      closeOnSelection,
      shouldFocusDisabledRows,
      interactiveRowSelectors: INTERACTIVE_MENU_ROW_SELECTORS,
      delayFocus: slideSubmenu ? MENU_SLIDE_DURATION_MS : void 0,
      isContentLabelledByTrigger
    });
    React16.useEffect(() => {
      if (!isOpen) {
        closeActiveSubmenu({ autoFocus: false });
      }
    }, [isOpen, closeActiveSubmenu]);
    const updateContent = React16.useCallback(() => {
      if (contentOverlayRef.current)
        contentOverlayRef.current.update();
    }, [contentOverlayRef]);
    const parentMenuContext = React16.useContext(MenuContext);
    const calculatedSlideSubmenu = _isSubmenu ? parentMenuContext.slideSubmenu : slideSubmenu;
    const closeMenuAndActiveSubmenu = React16.useCallback(
      (options2) => {
        if (contentRef && contentRef.current) {
          closeActiveSubmenu({});
          closeMenu(options2);
        }
      },
      [closeMenu, closeActiveSubmenu, contentRef]
    );
    const defaultValue2 = {
      isPortaled,
      contentRef,
      value,
      setSelected,
      setFocused,
      maxHeight,
      setMaxMenuHeight,
      isSubmenu: _isSubmenu,
      hasActiveSubmenu,
      topLevelTriggerRef: _isSubmenu ? parentMenuContext.topLevelTriggerRef : triggerRef,
      parentMenuContext: _isSubmenu ? parentMenuContext : void 0,
      menuRows,
      registerActiveSubmenu,
      closeActiveSubmenu,
      closeMenu,
      hasMaxHeight,
      shouldMatchContainerWidth: matchContainingWidth,
      slideSubmenu: calculatedSlideSubmenu,
      inverse,
      closeOnSelection
    };
    const options = {
      openMenu,
      closeMenu: closeMenuAndActiveSubmenu,
      toggleMenu,
      getTriggerProps,
      getContentProps: (options2) => ({
        ref: contentOverlayRef,
        open: Boolean(isOpen),
        triggerRef,
        ...getContentProps(options2)
      }),
      menuRows,
      triggerRef,
      contentRef,
      setSelected
    };
    const handleClickOutside = React16.useCallback(() => {
      if (closeOnBlur) {
        closeMenuAndActiveSubmenu({ ref: triggerRef, immediate: true });
      }
    }, [closeOnBlur, closeMenuAndActiveSubmenu, triggerRef]);
    const wrappedChildren = (
      // Only render the click outside container if this is a root menu
      !_isSubmenu ? /* @__PURE__ */ React16.createElement(
        ClickOutside,
        {
          className: classNames8("dig-Menu-backdrop", menuBackdropClassName),
          isBlock,
          onClickOutside: handleClickOutside,
          shouldPropagateMouseEvents: shouldPropagateClickOutsideMouseEvents,
          isClickThroughPortaled: isPortaled,
          isActive: Boolean(isOpen),
          shouldClickOutsideWhenDefaultPrevented: closeOnBlurWhenDefaultPrevented
        },
        children && children(options)
      ) : (
        // eslint-disable-next-line react-compiler/react-compiler
        children && children(options)
      )
    );
    React16.useImperativeHandle(ref, () => ({ focusTrigger, updateContent }), [
      focusTrigger,
      updateContent
    ]);
    return /* @__PURE__ */ React16.createElement(MenuContext.Provider, { value: defaultValue2 }, /* @__PURE__ */ React16.createElement("div", { className: cls, ...getRootProps(rest) }, wrappedChildren));
  }
);
Wrapper.displayName = "Wrapper";

// ../src/menu/submenu.tsx
var Submenu = ({
  id,
  withTriggerContent,
  withLeftAccessory,
  withRightAccessory,
  auto = true,
  placement = "right-start",
  contentClassName,
  disabled,
  children,
  openDelay = 0,
  triggerProps,
  contentProps,
  onSubmenuOpened,
  onSubmenuClosed,
  closeOnSelection,
  motionProvider = MenuMotion
}) => {
  const triggerRef = React17.useRef(null);
  const triggerTimeout = React17.useRef();
  const invokeCloseCallback = React17.useRef(true);
  const {
    menuRows,
    setSelected,
    registerActiveSubmenu,
    closeActiveSubmenu,
    isPortaled,
    slideSubmenu,
    topLevelTriggerRef,
    inverse
  } = React17.useContext(MenuContext);
  const { placement: contentPlacement, offset: contentOffset } = React17.useContext(MenuContentContext);
  const checkTimeout = () => {
    if (triggerTimeout.current) {
      clearTimeout(triggerTimeout.current);
      triggerTimeout.current = void 0;
    }
  };
  const handleSelection = (value, evt) => {
    const keepSubmenuOpen = closeOnSelection === false;
    setSelected(value, evt, { stayOpen: keepSubmenuOpen });
  };
  const onSubmenuContentOpened = React17.useCallback(() => {
    if (onSubmenuOpened) {
      onSubmenuOpened(id);
    }
  }, [id, onSubmenuOpened]);
  const openMenuWrapper = ({
    openMenu,
    closeMenu,
    autoFocus = false
  }) => {
    checkTimeout();
    invokeCloseCallback.current = false;
    closeActiveSubmenu();
    invokeCloseCallback.current = true;
    openMenu({ autoFocus: autoFocus || slideSubmenu });
    registerActiveSubmenu((options) => {
      const mergedOptions = options ? options : slideSubmenu ? { autoFocus: true, ref: triggerRef } : { autoFocus: false };
      closeMenuWrapper({
        closeMenu,
        options: mergedOptions
      });
    });
  };
  const closeMenuWrapper = ({
    closeMenu,
    options
  }) => {
    if (onSubmenuClosed && invokeCloseCallback.current) {
      onSubmenuClosed(id);
    }
    closeMenu(options || {});
  };
  const handleMouseLeave = (evt) => {
    checkTimeout();
    if (triggerProps && triggerProps.onMouseLeave) {
      triggerProps.onMouseLeave(evt);
    }
  };
  const createTriggerClick = ({
    openMenu,
    closeMenu,
    autoFocus = false
  }) => {
    return (evt) => {
      if (disabled)
        return;
      evt.stopPropagation();
      openMenuWrapper({ openMenu, closeMenu, autoFocus });
    };
  };
  const createSlidingCloseSubMenuClick = ({}) => {
    return () => {
      closeActiveSubmenu();
    };
  };
  const createSlidingCloseSubMenuKeyDown = ({}) => {
    return (evt) => {
      switch (evt.key) {
        case ENTER_KEY:
          evt.stopPropagation();
          closeActiveSubmenu();
          break;
      }
    };
  };
  const createHandleMouseEnter = ({ openMenu, closeMenu }) => (evt) => {
    if (disabled)
      return;
    if (triggerTimeout.current)
      return;
    if (slideSubmenu)
      return;
    if (triggerProps && triggerProps.onMouseEnter) {
      triggerProps.onMouseEnter(evt);
    }
    const performOpen = () => {
      openMenuWrapper({
        openMenu,
        closeMenu,
        autoFocus: false
      });
    };
    if (openDelay) {
      triggerTimeout.current = window.setTimeout(() => {
        performOpen();
      }, openDelay);
    } else {
      performOpen();
    }
  };
  const createTriggerHandleKeyDown = ({ openMenu, closeMenu }) => (evt) => {
    if (disabled)
      return;
    if (triggerProps && triggerProps.onKeyDown) {
      triggerProps.onKeyDown(evt);
    }
    switch (evt.key) {
      case ENTER_KEY:
        evt.stopPropagation();
        openMenuWrapper({ openMenu, closeMenu, autoFocus: true });
        return;
      case RIGHT_ARROW_KEY:
        openMenuWrapper({ openMenu, closeMenu, autoFocus: true });
        return;
    }
  };
  const createTriggerHandleKeyUp = ({ openMenu, closeMenu }) => (evt) => {
    if (triggerProps && triggerProps.onKeyUp) {
      triggerProps.onKeyUp(evt);
    }
    if (evt.key === SPACEBAR_KEY) {
      if (disabled)
        return;
      evt.stopPropagation();
      evt.preventDefault();
      openMenuWrapper({ openMenu, closeMenu, autoFocus: true });
    }
  };
  const createContentHandleKeyUp = ({ menuRows: menuRows2 }) => (evt) => {
    if (contentProps && contentProps.onKeyUp) {
      contentProps.onKeyUp(evt);
    }
    if (evt.key === SPACEBAR_KEY && isFocusingMenuRow(menuRows2.items, evt.target)) {
      evt.preventDefault();
    }
  };
  const createContentHandleKeyDown = ({
    menuRows: menuRows2,
    triggerRef: triggerRef2,
    closeMenu
  }) => (evt) => {
    if (contentProps && contentProps.onKeyDown) {
      contentProps.onKeyDown(evt);
    }
    switch (evt.key) {
      case TAB_KEY:
        evt.stopPropagation();
        closeMenuWrapper({ closeMenu, options: { autoFocus: true, ref: triggerRef2 } });
        return;
      case ESC_KEY:
        evt.stopPropagation();
        if (slideSubmenu) {
          closeMenuWrapper({
            closeMenu,
            options: { autoFocus: true, ref: topLevelTriggerRef, immediate: true }
          });
        } else {
          closeMenuWrapper({ closeMenu, options: { autoFocus: true, ref: triggerRef2 } });
        }
        return;
      case UP_ARROW_KEY:
        evt.stopPropagation();
        evt.preventDefault();
        const prevIndex = moveFocusBackward(menuRows2.items, menuRows2.selectedIndex);
        focusItem(menuRows2.items, prevIndex);
        menuRows2.setSelectedIndex(prevIndex);
        return;
      case DOWN_ARROW_KEY:
        evt.stopPropagation();
        evt.preventDefault();
        const nextIndex = moveFocusForward(menuRows2.items, menuRows2.selectedIndex);
        focusItem(menuRows2.items, nextIndex);
        menuRows2.setSelectedIndex(nextIndex);
        return;
      case LEFT_ARROW_KEY:
        evt.stopPropagation();
        evt.preventDefault();
        if (slideSubmenu) {
          closeActiveSubmenu();
        } else {
          closeMenuWrapper({ closeMenu, options: { autoFocus: true, ref: triggerRef2 } });
        }
        if (triggerRef2.current && "focus" in triggerRef2.current)
          triggerRef2.current.focus();
        return;
    }
  };
  React17.useEffect(() => {
    return () => {
      if (triggerTimeout.current) {
        clearTimeout(triggerTimeout.current);
      }
    };
  }, []);
  return /* @__PURE__ */ React17.createElement(
    Wrapper,
    {
      className: classNames9("dig-Menu--submenu", submenuClassName),
      onSelection: handleSelection,
      isPortaled,
      slideSubmenu,
      shouldFocusDisabledRows: menuRows.shouldFocusDisabledRows,
      _isSubmenu: true,
      inverse,
      closeOnSelection
    },
    ({ openMenu, closeMenu, getContentProps, getTriggerProps, menuRows: menuRows2 }) => /* @__PURE__ */ React17.createElement(React17.Fragment, null, /* @__PURE__ */ React17.createElement(
      Row,
      {
        id,
        interactive: true,
        disabled,
        withLeftAccessory,
        withRightAccessory: withRightAccessory || /* @__PURE__ */ React17.createElement(UIIcon2, { src: ChevronRightLine, size: "small" }),
        _isSubmenuTrigger: true,
        ...getTriggerProps(triggerProps),
        ref: triggerRef,
        onMouseEnter: createHandleMouseEnter({ openMenu, closeMenu }),
        onMouseLeave: handleMouseLeave,
        onKeyDown: createTriggerHandleKeyDown({ openMenu, closeMenu }),
        onKeyUp: createTriggerHandleKeyUp({ openMenu, closeMenu }),
        onClick: createTriggerClick({ openMenu, closeMenu })
      },
      withTriggerContent
    ), !disabled && /* @__PURE__ */ React17.createElement(
      Content,
      {
        ...getContentProps(contentProps),
        triggerRef: slideSubmenu ? topLevelTriggerRef : triggerRef,
        triggerOffset: slideSubmenu ? contentOffset : { crossAxis: -8 },
        auto,
        placement: slideSubmenu ? contentPlacement : placement,
        className: contentClassName,
        onKeyDown: createContentHandleKeyDown({
          menuRows: menuRows2,
          triggerRef,
          closeMenu
        }),
        onKeyUp: createContentHandleKeyUp({ menuRows: menuRows2 }),
        onContentOpened: onSubmenuContentOpened,
        motionProvider
      },
      slideSubmenu && /* @__PURE__ */ React17.createElement(Segment, null, /* @__PURE__ */ React17.createElement(
        Row,
        {
          interactive: true,
          disabled,
          withLeftAccessory: /* @__PURE__ */ React17.createElement(UIIcon2, { src: ChevronLeftLine, size: "small" }),
          onClick: createSlidingCloseSubMenuClick({ closeMenu }),
          onKeyDown: createSlidingCloseSubMenuKeyDown({ closeMenu })
        },
        withTriggerContent
      )),
      children
    ))
  );
};
Submenu.displayName = "Submenu";

// ../src/menu/menu.ts
var Menu = {
  ActionItem,
  Canvas,
  Content,
  LinkItem,
  Row,
  RowAccessory,
  RowContent,
  RowSubtitle,
  RowTitle,
  Segment,
  SelectItem,
  Submenu,
  Wrapper
};
export {
  BACKSPACE_KEY,
  DELETE_KEY,
  DOWN_ARROW_KEY,
  ENTER_KEY,
  ESC_KEY,
  FOCUSABLE_SELECTOR,
  LAST_SELECTED_INDEX,
  LEFT_ARROW_KEY,
  Menu,
  NONE_SELECTED_INDEX,
  RIGHT_ARROW_KEY,
  SPACEBAR_KEY,
  TAB_KEY,
  UP_ARROW_KEY,
  VISUALLY_HIDDEN_CSS,
  buttonContentDataAttributeName,
  buttonContentDataSelector,
  buttonDataAttributeName,
  buttonDataSelector,
  iconButtonDataAttributeName,
  iconButtonDataSelector,
  splitButtonDataAttributeName,
  splitButtonDataSelector
};
